module.exports = " <div class=default> <h1><img src=" + require("appAsset/ic_no_access.png") + " alt=\"\"></h1> <p class=no-access>您的账号当前没有访问权限</p> <p class=contact>请联系后台管理员为您授权</p> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/appBackend/components/page/default/default403.vue
// module id = 1127
// module chunks = 2